import { vanillaUserAndOrganizationStore } from '../state'
import type { AccessListItem, Action, ResourceType } from '../types/action'

// Actions are populated for the user `roles` in Contrast-UI (app.controller.ts)
export const userHasAction = (action: Action): boolean => {
  const { currentUser } = vanillaUserAndOrganizationStore.getState()
  return !!currentUser?.roles?.some((act: Action) => act === action.trim())
}

export const getUserResourceAccess = (
  resourceType: ResourceType
): { actions: Action[]; resourceItems: AccessListItem } => {
  const { currentUser } = vanillaUserAndOrganizationStore.getState()
  const resourceItems = currentUser?.accessList || {}
  const actions = resourceItems[resourceType] || []
  return { actions: actions as Action[], resourceItems }
}

// For consistency, the parameters are in the same order as `hasResourcePermission` is in Contrast-UI
export const userHasResourceAction = (resourceType: ResourceType, action: Action): boolean => {
  const { actions } = getUserResourceAccess(resourceType)
  return actions?.some((act: Action) => act === action.trim())
}
